export const ROLES = {
  MANAGER: "MANAGER",
  DOCTOR: "DOCTOR",
  COUNTER: "COUNTER",
  ASSISTANT: "ASSISTANT",
  HEADCOUNTER: "HEADCOUNTER",
  ROLE_BRANCH_STOCK_MANAGER: "ROLE_BRANCH_STOCK_MANAGER",
  ROLE_STOCK_STAFF: "ROLE_STOCK_STAFF",
  ROLE_SPECIAL_STOCK_ADJUSTER: "ROLE_SPECIAL_STOCK_ADJUSTER",
};
